import type { CSSProperties } from "react";

/** Turns an inline-style string ("a:b;c:d") into a React style object. */
export function cssStr(s: string | undefined): CSSProperties {
  const out: Record<string, string> = {};
  for (const decl of (s ?? "").split(";")) {
    const i = decl.indexOf(":");
    if (i < 0) continue;
    const k = decl.slice(0, i).trim();
    const v = decl.slice(i + 1).trim();
    if (!k) continue;
    out[k.startsWith("--") ? k : k.replace(/-(\w)/g, (_, c: string) => c.toUpperCase())] = v;
  }
  return out as CSSProperties;
}
